<template lang="pug">
div
  .filter.no-print
    form(@submit.prevent="onFilter")
      .form-group
        label.form-radio.form-inline.input-sm(v-for="(tipo, k) in tipos")
          input(
            type="radio",
            :value="k",
            v-model="q.situacao_tipo_eq",
            @change="onFilter",
            :disabled="loading"
          )
          i.form-icon
          | {{ tipo }}
        button.btn.btn-primary.btn-sm.s-circle.tooltip.tooltip-left.float-right(
          data-tooltip="Filtrar",
          :disabled="loading"
        )
          i.icon.icon-search
</template>

<script>
import { deepKey } from "paliari-js-utils";

export default {
  vuex: {
    docs: {
      state: ["query"],
      actions: ["fetchList"],
      mutations: ["setPage", "setQuery"],
      getters: ["filtered", "loading"],
    },
  },
  data() {
    return {
      q: {
        situacao_tipo_eq: "aguardando_ciencia",
        created_at_order_by: "desc",
      },
    };
  },
  computed: {
    tipos() {
      return {
        aguardando_ciencia: "Aguardando ciência",
        andamento: "Em andamento",
        defesa: "Defesa",
        concluido: "Concluído",
      };
    },
  },
  methods: {
    onFilter() {
      this.setQuery({ ...this.q });
      this.setPage(1);
      this.fetchList();
    },
    clearFilter(query = {}) {
      this.q = query;
      this.onFilter();
    },
  },
  created() {
    const scope = deepKey(this.$route, "query.scope");
    if (scope) {
      this.q.situacao_tipo_eq = scope;
    }
    if (!(this.list && this.list.length)) {
      this.onFilter();
    }
  },
};
</script>

<style lang="stylus" scoped>
.form-inline {
  white-space: nowrap;
}
</style>
